module.exports = __webpack_public_path__ + "static/buergerforum-c726ba94563a0d35c2803f65f021144c.png";